import { CommonWrap } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";
import { useLocales } from "@/locales";
import { Trans } from "react-i18next";
import CodeSnippet from "@/components/CodeSnippet";
import ShowTable from "@/DocLayout/Table/index";
import { GET_COIN_LIST_URL } from "@/config";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { useContext } from "react";
import { codeMap } from "@/PageCodeComponents/PublicResourceApi/index";
import PostRequest from "@/components/PostRequest";

export default function GetCoinList() {
  const { translate } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);

  return (
    <>
      <ContentWrap
        id="common-api"
        showBorderBottom={false}
        leftChildrenSx={{
          paddingBottom: "1px",
        }}
        leftChildren={
          <CommonWrap>
            <Box component={"div"} className="title" mt={3}>
              {translate("public_resource.common_api")}
            </Box>

            <Box
              id="get-token-list"
              component={"div"}
              className="title_0"
              mt={3}
            >
              {translate("public_resource.get_coin_list_title")}
            </Box>

            <Box component={"div"} className="desc" mb={3}>
              {translate("public_resource.get_coin_list_desc")}
            </Box>

            <Box component={"div"} className="title_1" mt={3}>
              {translate("common.http_request")}
            </Box>
            <PostRequest url={GET_COIN_LIST_URL} />
          </CommonWrap>
        }
      />
      <ContentWrap
        showBorderBottom={false}
        leftChildrenSx={{
          paddingTop: "32px",
          paddingBottom: "1px",
        }}
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_params")}</Box>
            <ShowTable
              isEmpty={true}
              isEmptyText={translate("common.no_requset_param")}
              tableData={[]}
            />
          </CommonWrap>
        }
        rightChildren={
          <>
            <CodeSnippet
              title={translate("common.http_request_ex")}
              code={codeMap["coin_list"][language].http_ex_code}
            />
          </>
        }
      />

      {/* 返回参数 */}

      <ContentWrap
        leftChildrenSx={{
          paddingTop: "2px",
        }}
        leftChildren={
          <CommonWrap>
            <Box component={"div"} className="title_1" mt={3}>
              {translate("common.http_res")}
            </Box>

            <ShowTable
              res={true}
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: " ",
                },
                {
                  name: "data.coins",
                  type: "Array",
                  desc: " ",
                },
                {
                  name: "data.coins[index].coinId",
                  type: "Integer",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc1"
                  ),
                },
                {
                  name: "data.coins[index].symbol",
                  type: "String",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc2"
                  ),
                },
                {
                  name: "data.coins[index].logoUrl",
                  type: "String",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc3"
                  ),
                },
                {
                  name: "data.coins[index].status",
                  type: "String",
                  desc: (
                    <Box
                      component={"div"}
                      className="code"
                      sx={{
                        code: {
                          lineHeight: "32px",
                        },
                      }}
                    >
                      <Trans
                        i18nKey={
                          "public_resource.get_coin_list_res_table_desc4"
                        }
                        t={translate as any}
                      >
                        Just a placeholder
                        <code>Just a placeholder</code>
                        <code>Just a placeholder</code>
                        <code>Just a placeholder</code>
                        <code>Just a placeholder</code>
                      </Trans>
                    </Box>
                  ),
                },
                {
                  name: "data.coins[index].networks",
                  type: "Object",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc5"
                  ),
                },

                {
                  name: "data.coins[index].networks.AVAX",
                  type: "Object",
                  desc: " ",
                },
                {
                  name: "data.coins[index].networks.AVAX.chain",
                  type: "String",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc6"
                  ),
                },
                {
                  name: "data.coins[index].networks.AVAX.chainFullName",
                  type: "String",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc7"
                  ),
                },
                {
                  name: "data.coins[index].networks.AVAX.contract",
                  type: "String",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc8"
                  ),
                },
                {
                  name: "data.coins[index].networks.AVAX.precision",
                  type: "Integer",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc9"
                  ),
                },
                {
                  name: "data.coins[index].networks.AVAX.canDeposit",
                  type: "Boolean",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc10"
                  ),
                },
                {
                  name: "data.coins[index].networks.AVAX.canWithdraw",
                  type: "Boolean",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc11"
                  ),
                },
                {
                  name: "data.coins[index].networks.AVAX.minimumDepositAmount",
                  type: "String",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc12"
                  ),
                },
                {
                  name: "data.coins[index].networks.AVAX.minimumWithdrawAmount",
                  type: "String",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc13"
                  ),
                },
                {
                  name: "data.coins[index].networks.AVAX.maximumWithdrawAmount",
                  type: "String",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc14"
                  ),
                },
                {
                  name: "data.coins[index].networks.AVAX.isSupportMemo",
                  type: "Boolean",
                  desc: translate(
                    "public_resource.get_coin_list_res_table_desc15"
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <>
            <CodeSnippet
              title={translate("common.http_result")}
              code={codeMap["coin_list"].response}
            />
          </>
        }
      />
    </>
  );
}
